import { EmptyMessage } from './EmptyMessage'

export const EmptyStatement = () => {
  return (
    <EmptyMessage
      className="w-full"
      title="Nenhum extrato registrado"
      description="Aqui será exibido o histórico de extrato de comissão do usuário."
    />
  )
}
